<template>
	<div  v-shortkey="['esc']" @shortkey="showModal = false" @keyup.up="up()" @keyup.down="down()" @keyup.enter="enter()" @keyup.esc.stop="showModal = false">
		<div class="input-group input-group-md">
			<input :class="{'has-danger': $props.showTextDangerProfissional}" type="text" class="form-control" :disabled="true" :value="$props.nomeProfissionalRecuperado ? $props.nomeProfissionalRecuperado : profissionalSelecionado.nome" :placeholder="placeholder">
			<div class="input-group-btn">
				<button ref="btnBuscarProfissional" v-shortkey="['alt', '3']" @shortkey="showModal = true, focoNomeProfissional()" :class="{'btn-danger': $props.showTextDangerProfissional, 'btn-default': !$props.showTextDangerProfissional}" :disabled="$props.nomeProfissional != undefined"
				    type="button" @click="showModal = true, focoNomeProfissional()" class="btn btn-flat">
							<i class="fa fa-search"></i>
						</button>
				<button :disabled="disableClear" ref="btnBuscarLimpar" :class="{'btn-danger': $props.showTextDangerProfissional, 'btn-default': !$props.showTextDangerProfissional}" type="button" @click="limpar()" class="btn btn-flat"><i class="fa fa-trash-o"></i></button>
			</div>
		</div>

		<transition name="modal">
			<div class="modal-mask not-valited" v-show="showModal">
				<div class="modal-container">
					<div class="modal-header">
						<h3>Selecionar Profissional</h3>
					</div>
					<div class="modal-body">

						<div class="row" v-if="unidadeSolicitanteSelecionada">
							<div class="col-sm-12">
								<div class="form-group">
									<label for="">Unidade solicitante</label>
									<input class="form-control" disabled :value="$props.unidadeSolicitanteSelecionada.nome" type="text">
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-sm-12">
								<input v-shortkey="['ctrl', 'b']" @shortkey="getDataTable()" title="[ ctrl + b ] Para pesquisar" ref="inputProfissional" type="text" class="form-control" v-model="filtros.pesquisa"  placeholder="Pesquisa: Entre com o nome ou CNS do profissional e pressione ctrl + b."
								/>
							</div>
						</div>

						<div class="row" v-if='loading'>
							<div class="col-sm-12" style="text-align: center; margin-top:30px;">
								<br/>
								<span style="text-align: center">Aguarde, processando...</span>
							</div>
						</div>

						<div class="row" style="margin-top:15px" v-else>
							<div class="col-sm-12 table-responsive">
								<table role="grid" class="table table-bordered table-striped table-hover">
									<thead>
										<tr role="row">
											<th style="width: 10%">ID</th>
											<th style="width: auto">CNS</th>
											<th style="width: auto">Nome</th>
										</tr>
									</thead>
									<tbody>
										<tr @click="seleciona(item)" :class="{'ativa': index === profissionalSelecionadoIndex}" class="even hand" role="row" v-for="(item, index) in dataTable.data" :key="index">
											<td>{{ item.id }}</td>
											<td>{{ item.cns }}</td>
											<td>{{ item.nome }}</td>
										</tr>
									</tbody>
								</table>
								<div class="row">
									<div class='col-sm-5'>
										Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.
									</div>
									<div class='col-sm-7' style="text-align:right">
										<laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
											<span slot="prev-nav">&lt; Anterior</span>
											<span slot="next-nav">Próximo &gt;</span>
										</laravue-pagination>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="text-right" style="float:right">
							<button type="button" class="btn btn-default" @click="showModal = false"><i class="fa fa-close"></i> Fechar</button>
						</div>
					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
	$_veeValidate: {
		name() {
			return this.name;
		},
		value() {
			return this.profissionalSelecionado.nome;
		}
	},
	filters: {},
	// props: ["nomeProfissional", "showTextDangerProfissional", "tipoProfissional"],
	props: {
		disableClear: false,
		unidadeSolicitanteSelecionada: {
			default: null
		},
		nomeProfissional: {},
		nomeProfissionalRecuperado: {},
		showTextDangerProfissional: {
			default: false
		},
		tipoProfissional: {},
		placeholder: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
	},
	data: () => ({
		loading: false,
		profissionalSelecionadoIndex: 0,
		profissionalSelecionado: {},
		filtros: {
			pesquisa: '',
		},
		showModal: false,
		dataTable: {
			data: []
		}
	}),
	mounted() {
		// console.log(this.$props.nomeProfissional);
		// this.getDataTable();
	},
	methods: {
		getDataTable(page) {
			if (typeof page === 'undefined') {
				page = 1;
			}

			this.filtros.page = page;
			this.$store.commit('TOGGLE_LOADING');

			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			axios.get(`${this.$store.state.serverURI}/api/cadastros/profissionais/getAllPaginate`, config)
				.then(response => {
					this.dataTable = response.data;
					this.$store.commit('TOGGLE_LOADING');
				}).catch((error) => {
					this.$store.commit('throwException', error);
				});

		},
		limpar() {
			this.seleciona({ id: null, nome: '' })
		},
		seleciona(item) {
			this.$emit("input", item.nome);
			this.profissionalSelecionado = item;
			this.showModal = false;
			if (this.$props.tipoProfissional) {
				this.$emit('setProfissional' + this.$props.tipoProfissional + 'Selecionado', item);
			} else {
				this.$emit('setProfissionalSelecionado', item);
			}
		},
		abrirModal() {
			this.$refs.btnBuscarProfissional.click();
		},
		focoNomeProfissional() {
			this.$nextTick(function() {
				this.$refs.inputProfissional.focus();
			})
		},
		up() {
			if (this.profissionalSelecionadoIndex > 0) {
				this.profissionalSelecionadoIndex--;
			}
			console.log("profissionalSelecionadoIndex : " + this.profissionalSelecionadoIndex);
		},
		down() {
			if (this.profissionalSelecionadoIndex < this.dataTable.data.length - 1) {
				this.profissionalSelecionadoIndex++;
			}
			console.log("profissionalSelecionadoIndex : " + this.profissionalSelecionadoIndex);
		},
		enter() {
			this.seleciona(this.dataTable.data[this.profissionalSelecionadoIndex]);
		},
		selecionaIndex() {
			console.log("Enter ");
			console.log(this.dataTable[1]);
		}
	},
	watch: {
		"$props.nomeProfissional": function(value) {
			if (value) {
				this.profissionalSelecionado.nome = value;
			}
		},
	},
	components: {}
};
</script>

<style scoped>
* {
	box-sizing: border-box;
}

.modal-mask {
	position: fixed;
	z-index: 999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	transition: opacity 0.3s ease;
}

.modal-container {
	width: 70%;
	margin: 40px auto 0;
	padding: 10px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #333;
}

.modal-body {
	margin: 10px 0;
}

.text-right {
	text-align: right;
}

.form-label {
	display: block;
	margin-bottom: 1em;
}

.form-label>.form-control {
	margin-top: 0.5em;
}

.form-control {
	display: block;
	width: 100%;
	padding: 0.5em 1em;
	line-height: 1.5;
	border: 1px solid #ddd;
}

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.modal {
	display: block !important;
	/* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
	overflow-y: initial !important;
}

.modal-body {
	height: 350px;
	overflow-y: auto;
}

.has-danger {
	border-color: #D73925
}

table {
	font-size: 12px;
}

.not-valited .form-control {
	border-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// selectProfissional.vue?7236b1fb